export const GoPhishAccountAPIKey = process.env.REACT_APP_GOPHISH_ACCOUNT_API
export const GoPhishLocalURL = process.env.REACT_APP_GOPHISH_LOCAL_SERVER_URL
export const GoPhishPublicURL = process.env.REACT_APP_GOPHISH_PUBLIC_SERVER_URL
export const BackendURL = process.env.REACT_APP_BASE_URL